import { Injectable } from '@angular/core';
import moment from 'moment';
import { AnalyticsServiceSpa } from 'src/app/generated/services/analytics/analyticsSpa';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  constructor(private _analyticsService: AnalyticsServiceSpa) { }

  addCounter(url: string) {
    const t = moment();
    return this._analyticsService.updateCounter({
      url: url,
      isoDate: t.toISOString(true),
      timestamp: t.unix() * 1000,
    });
  }
}
